var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {},
    [
      _vm.showCsv
        ? [
            _c("ValidationObserver", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ invalid }) {
                      return [
                        _vm._l(_vm.csvParseOutput, function (item, index) {
                          return _c("UserInvitationData", {
                            key: index,
                            attrs: {
                              userEmail: item.email,
                              userGivenName: item.givenName,
                              userFamilyName: item.familyName,
                              processing: item.processing,
                              userId: item.id,
                              companyId: _vm.companyId,
                              index: index,
                              userSource: _vm.csvParseOutput,
                              isManager: _vm.isManager,
                              usersToCheck: _vm.csvParseOutput,
                              allowedAdding: _vm.isAddingUserAllowed(index),
                              allowDelete: _vm.isDeleteAllowed(
                                _vm.csvParseOutput
                              ),
                              is_public: item.is_public,
                              validateCsv: "",
                              immediate: "",
                            },
                            on: {
                              "update:userEmail": function ($event) {
                                return _vm.$set(item, "email", $event)
                              },
                              "update:user-email": function ($event) {
                                return _vm.$set(item, "email", $event)
                              },
                              "update:userGivenName": function ($event) {
                                return _vm.$set(item, "givenName", $event)
                              },
                              "update:user-given-name": function ($event) {
                                return _vm.$set(item, "givenName", $event)
                              },
                              "update:userFamilyName": function ($event) {
                                return _vm.$set(item, "familyName", $event)
                              },
                              "update:user-family-name": function ($event) {
                                return _vm.$set(item, "familyName", $event)
                              },
                              "update:processing": function ($event) {
                                return _vm.$set(item, "processing", $event)
                              },
                              "update:userId": function ($event) {
                                return _vm.$set(item, "id", $event)
                              },
                              "update:user-id": function ($event) {
                                return _vm.$set(item, "id", $event)
                              },
                              "update:is_public": function ($event) {
                                return _vm.$set(item, "is_public", $event)
                              },
                              delete: _vm.deleteCsvEntry,
                            },
                          })
                        }),
                        _vm._t("lastParsedCSVLine"),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center pt-4 justify-between border-t border-gray-200",
                          },
                          [
                            _c("div", { staticClass: "flex items-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-base text-badgeBlue space-x-2 flex mr-2 self-end",
                                },
                                [_c("p", [_vm._v(_vm._s(_vm.csvFilename))])]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("parsedCsvChange", [])
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "10",
                                        height: "22",
                                        viewBox: "0 0 10 22",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M8.68501 7.86321C9.01811 7.53012 9.01811 6.98917 8.68501 6.65607C8.35192 6.32298 7.81097 6.32298 7.47787 6.65607L4.67187 9.46474L1.86321 6.65874C1.53012 6.32564 0.989168 6.32564 0.656072 6.65874C0.322976 6.99183 0.322976 7.53278 0.656072 7.86588L3.46474 10.6719L0.658737 13.4805C0.325641 13.8136 0.325641 14.3546 0.658737 14.6877C0.991832 15.0208 1.53278 15.0208 1.86588 14.6877L4.67187 11.879L7.48054 14.685C7.81363 15.0181 8.35458 15.0181 8.68768 14.685C9.02077 14.3519 9.02077 13.811 8.68768 13.4779L5.87901 10.6719L8.68501 7.86321Z",
                                          fill: "#717986",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "flex flex-row" },
                              [
                                _c("UiButton", {
                                  staticClass: "mr-3",
                                  attrs: {
                                    variant: "outline",
                                    buttonClasses: "customButtonCard",
                                    buttonText: "Cancel",
                                  },
                                  on: { click: _vm.handleClose },
                                }),
                                _c("UiButton", {
                                  staticClass: "ml-auto",
                                  attrs: {
                                    variant: "black",
                                    buttonClasses: "customButtonCard",
                                    buttonText: _vm.loading
                                      ? "Loading..."
                                      : "Invite",
                                    disabled: invalid,
                                  },
                                  on: { click: _vm.handleCsvSubmit },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        : [
            _vm._t("default", function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full flex justify-center px-4 pt-5 mb-5 border border-primary-color drop-file-container",
                    on: {
                      drop: function ($event) {
                        $event.preventDefault()
                        return _vm.addFile.apply(null, arguments)
                      },
                      dragover: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _c("span", { staticClass: "flex justify-center mb-3" }, [
                        _c(
                          "span",
                          { staticClass: "p-5 rounded-full bg-primary" },
                          [
                            _c("PicturePlaceholderIcon", {
                              staticClass: "text-white h-5 w-5",
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("p", { staticClass: "mt-1 text-low text-gray-600" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "text-primary-500 hover:text-primary-800 focus:outline-none focus:underline transition duration-150 ease-in-out underline hover:no-underline",
                            attrs: { type: "button" },
                            on: { click: _vm.handleFileUpload },
                          },
                          [_vm._v(" Upload CSV ")]
                        ),
                        _vm._v(" or drag and drop "),
                      ]),
                      _c("input", {
                        ref: "fileUpload",
                        attrs: { type: "file", accept: ".csv", hidden: "" },
                        on: { change: _vm.addFile },
                      }),
                    ]),
                  ]
                ),
              ]
            }),
            _c("ModalSectionsDivider"),
            _c(
              "div",
              { staticClass: "pt-5 text-sm flex justify-end" },
              [
                _c("UiButton", {
                  staticClass: "mr-3",
                  attrs: {
                    buttonText: "Cancel",
                    size: "lg",
                    buttonClasses: "customPadding",
                    variant: "outline-black",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                }),
                _c("UiButton", {
                  ref: "sample",
                  staticClass: "mr-3",
                  attrs: {
                    buttonText: "Download Sample CSV",
                    size: "lg",
                    buttonClasses: "customPadding",
                    variant: "black",
                  },
                  on: { click: _vm.downloadSampleCsv },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }